import { addNewDoctor } from "./addNewDoctorForm";
import { addNewPatient } from "./addNewPatientForm";
import { addNewMedication } from "./addNewMedicationForm";
import { loginSchema } from "./auth/loginForm";
import { medicationFormSchema } from "./patients/medicationForm";

export const forms = {
  addNewDoctor,
  addNewPatient,
  addNewMedication,
  loginSchema,
  medicationFormSchema,
};

export * from "./addNewPatientForm";
export * from "./addNewDoctorForm";
export * from "./addNewMedicationForm";
export * from "./auth/loginForm";
export * from "./patients/medicationForm";
